import * as React from "react";
import { TextField } from "@mui/material";
import { Theme, darken, lighten } from "@mui/material/styles";
import { FieldLabelWithHelp } from "./FieldHelpIcon";

type InputTextProps = {
  label: string;
  value: string;
  helperText?: string;
  error?: boolean;
  // Aviso que no bloquea: el helperText se pinta de advertencia. Un error lo tapa.
  warning?: boolean;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  customWidth?: number;
  disabled?: boolean;
  hidden?: boolean;
  placeholder?: string;
  nullText?: string;
  description?: string;
};

export const InputText: React.FC<InputTextProps> = ({
  label,
  value,
  onChange,
  helperText = "",
  error = false,
  warning = false,
  autoFocus = false,
  customWidth = 500,
  disabled = false,
  hidden = false,
  placeholder,
  nullText,
  description,
}) => {
  const [focused, setFocused] = React.useState(false);
  if (hidden) return null;
  const isEmpty = value === "" || value === null || value === undefined;
  const showLabelInside = description && isEmpty && !focused;
  const baseLabel =
    nullText && isEmpty && !focused ? `${label} (${nullText})` : label;
  const displayLabel = showLabelInside ? undefined : baseLabel;
  const effectivePlaceholder = showLabelInside
    ? nullText
      ? `${label} (${nullText})`
      : label
    : placeholder;
  return (
    <TextField
      disabled={disabled}
      autoFocus={autoFocus}
      size={"small"}
      multiline
      rows={4}
      maxRows={40}
      inputProps={{ autoComplete: "one-time-code" }}
      variant="outlined"
      error={error}
      helperText={helperText}
      FormHelperTextProps={
        warning && !error
          ? {
              sx: {
                color: (theme: Theme) =>
                  theme.palette.mode === "dark"
                    ? lighten(theme.palette.warning.main, 0.5)
                    : darken(theme.palette.warning.main, 0.5),
              },
            }
          : undefined
      }
      sx={{ m: 1, width: customWidth, textarea: { resize: "both" } }}
      label={
        <FieldLabelWithHelp label={displayLabel} description={description} />
      }
      InputLabelProps={description ? { shrink: true } : undefined}
      value={value}
      placeholder={effectivePlaceholder}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onChange={(event) => onChange(event.target.value)}
    />
  );
};
